import React from 'react';
import { css } from 'emotion';
import { Icon } from '../../../../shared/Icon';
import { IconType } from '../../../../shared/Icon/types/index.d';
import {
  StepsSection,
  StepsContainer,
  StepContainer,
  IconWrapper,
  StepHeader,
  StepText,
} from './styles';

export function Steps() {
  return (
    <StepsSection>
      <StepsContainer>
        <Step
          header="Step 1"
          text="Connect your blog to Anchor"
          icon="Sync"
          padding={18}
        />
        <Step
          header="Step 2"
          text="Record or convert your posts to audio"
          icon="microphone"
        />
        <Step
          header="Step 3"
          text="Reach listeners everywhere"
          icon="headphones"
          padding={18}
        />
      </StepsContainer>
    </StepsSection>
  );
}

function Step({
  header,
  text,
  icon,
  padding = 14,
}: {
  header: string;
  text: string;
  icon: IconType;
  padding?: number;
}) {
  return (
    <StepContainer>
      <IconWrapper padding={padding}>
        <Icon type={icon} fillColor="#fff" />
      </IconWrapper>
      <StepHeader>{header}</StepHeader>
      <StepText>{text}</StepText>
    </StepContainer>
  );
}
